// extracted by mini-css-extract-plugin
module.exports = {"usp":"confirm-module--usp--1E6oO","cancel":"confirm-module--cancel--3gpQX"};